import * as turf from '@turf/turf';
import * as martinez from 'martinez-polygon-clipping';
import { rectangularGrid } from './rectangularGrid';
const intersection = (polygons, area) => {
    const polygonsInsideIntersection = [];
    turf.featureEach(polygons, (gridEl) => {
        if (area.geometry && gridEl.geometry) {
            const intersectionCoordinates = martinez.intersection(area.geometry.coordinates, gridEl.geometry.coordinates);
            if (intersectionCoordinates && intersectionCoordinates.length > 0) {
                const polyPosition = intersectionCoordinates[0];
                polygonsInsideIntersection.push(polyPosition);
            }
        }
    });
    return turf.multiPolygon(polygonsInsideIntersection);
};
export const createGrid = ({ geometry, rotate, hSpace, vSpace }) => {
    let featureListGrid = [];
    turf.featureEach(geometry, (currentFeature) => {
        const rotateOriginalFeature = turf.transformRotate(currentFeature, rotate);
        const featureUnionRotatedFeature = turf.union(currentFeature, rotateOriginalFeature);
        const featureInRotatedContext = turf.transformScale(featureUnionRotatedFeature, 3);
        const bboxInRotatedContext = turf.bbox(featureInRotatedContext);
        const gridInRotatedContext = rectangularGrid(bboxInRotatedContext, hSpace, vSpace);
        const grid = turf.transformRotate(gridInRotatedContext, rotate);
        const clippedGrid = intersection(grid, currentFeature);
        featureListGrid = featureListGrid.concat(clippedGrid);
    });
    return turf.featureCollection(featureListGrid);
};
//# sourceMappingURL=createGrid.js.map